export const getPlainText = (htmlString: string): string => {
  const htmlWithSpace = htmlString.replace(/<p>(.*?)<h2>/g, '$1 ');
  return htmlWithSpace.replace(/<[^>]+>/g, '');
};
